import axios from 'axios'
import get from 'lodash/get'

import store from '@/store'
import { getToken } from '@/utils/auth'
import { Notification } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_V2_BASE_API,
  timeout: 25000
})

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers.Authorization = 'Bearer ' + getToken()
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (process.env.NODE_ENV !== 'production') {
      console.error(error)
    }

    Notification({
      type: 'error',
      title: 'Error',
      message: get(error, 'response.data.message') || error.message
    })

    return Promise.reject(error)
  }
)

export default service
